import React from 'react';
import tw from 'tailwind-styled-components';
import { Link } from 'gatsby';
import { navigation } from '../util/constants';
import { Button } from './shared/Buttons';
import { Body, Small } from './shared/Types';
import TangoLogo from '../images/svg/TangoLogo.svg';
import { ReactComponent as Instagram } from '../images/svg/Instagram.svg';
import { ReactComponent as Linkedin } from '../images/svg/Linkedin.svg';
import { ReactComponent as Twitter } from '../images/svg/Twitter.svg';

const Gradient = tw.div`
  h-20
  bg-gradient-to-b
  from-teal-20
  to-white
  md:h-40
`;

const FooterContainer = tw.footer`
  bg-white
  text-blue-100
`;

const MainWrapper = tw.div`
  max-w-screen-desktop
  m-auto
  mx-5
  py-10
  lg:mx-10
  3xl:mx-auto
`;

const GridWrapper = tw.div`
  gap-8
  grid
  grid-rows-[40px_1fr]
  lg:gap-x-16
  lg:grid-cols-[160px_1fr]
  lg:grid-rows-none
  xl:gap-x-24
  2xl:gap-x-32
`;

const ColumnWrapper = tw.div`
  grid-cols-4
  hidden
  items-start
  pb-10
  md:grid
`;

const ColumnContainer = tw.div`
  flex
  flex-1
  flex-col
  flex-wrap
`;

const NavigationItem = tw(Link)`
  py-4
  text-blue-80
  transition-all
  hover:text-blue-100
  hover:font-medium
`;

const LinkToItem = tw.a`
  cursor-pointer
  py-4
  text-blue-80
  transition-all
  hover:text-blue-100
  hover:font-medium
`;

const SocialContainer = tw.div`
  flex
  flex-row
  gap-x-4
  items-center
  pb-3
`;
 
const SocialItem = tw.a`
  gap-x-4
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <Gradient />
      <MainWrapper>
        <GridWrapper>
          <img src={TangoLogo} alt="Tango Logo" className="max-w-[160px]"/>
          <ColumnWrapper>
            <ColumnContainer>
              <Body className="mb-4">Sitemap</Body>
              {
                navigation.map(item => (
                  <NavigationItem
                    key={`footer-${item.name}`}
                    to={item.href}
                  >
                    {item.name}
                  </NavigationItem>
                ))
              }
            </ColumnContainer>
            <ColumnContainer>
              <Body className="mb-4">New Business</Body>
              <LinkToItem to="mailto:contact@tango.io">contact@tango.io</LinkToItem>
              <Body className="mt-4 mb-8">507 - 412 - 3468</Body>
              <div className="flex">
                <Button className="w-max" size="small" to='/contact' type="secondary">
                  Work with us
                </Button>
              </div>
            </ColumnContainer>
            <ColumnContainer>
              <Body className="mb-4">Careers</Body>
              <LinkToItem className="mb-4" to="mailto:careers@tango.io">careers@tango.io</LinkToItem>
              <div className="flex">
                <Button className="w-max" size="small" to="/careers" type="secondary">
                  Join us
                </Button>
              </div>
            </ColumnContainer>
            <ColumnContainer>
              <NavigationItem className="pt-0" to="/privacy_policy">Privacy Policy</NavigationItem>
              <NavigationItem to="/terms_and_conditions">Terms & Conditions</NavigationItem>
              <NavigationItem to="/cookies_policy">Cookies Policy</NavigationItem>
            </ColumnContainer>
          </ColumnWrapper>
        </GridWrapper>
        <SocialContainer>
            <Small>Follow us</Small>
            <SocialItem href="https://www.linkedin.com/company/tango-io/" target="_blank"><Linkedin className="bg-[#0072B1] w-7 rounded-lg" /></SocialItem>
            <SocialItem href="https://www.instagram.com/tangodotio/" target="_blank"><Instagram className="bg-[#E91E63] w-7 rounded-lg" /></SocialItem>
            <SocialItem href="https://twitter.com/tango_io" target="_blank"><Twitter className="bg-[#1DA1F2] w-7 rounded-lg" /></SocialItem>
        </SocialContainer>
        <Small>© { currentYear } TangoSource LLC. All rights reserved.</Small>
      </MainWrapper>
    </FooterContainer>
  );
};

export default Footer;
